import { useMemo } from 'react';
import type { MlsVendorOption } from 'src/components/MlsVendorAutocomplete';
import { useIdentity } from '$api-clients/hooks';

/**
 * One MLS from identity's catalog, by id. Resolves a saved
 * `property.mlsServiceId` that the state-scoped list can't surface — an MLS
 * that doesn't serve the property's state, a property with no state, or a
 * retired entry with a blanked providerId. Unlike the list hooks this does
 * NOT drop provider-less entries: a retired MLS still shows its name, it
 * just can't be searched.
 */
export const useMlsById = (mlsId?: string | null) => {
  const { data, isLoading, error } = useIdentity(
    '/multiple-listing-services/{mlsId}',
    mlsId ? { params: { path: { mlsId } } } : null,
  );

  const mlsVendorOption: MlsVendorOption | null = useMemo(
    () =>
      data
        ? {
            id: data.id,
            name: data.name,
            code: data.code,
            providerId: data.providerId?.trim() ?? '',
            listingIdTip: data.listingIdTip ?? null,
            locales: data.locales,
          }
        : null,
    [data],
  );

  return { mlsVendorOption, loading: isLoading, error };
};
